import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import ImageGallery from 'react-image-gallery';
import reactImageSize from 'react-image-size';

import Sketchbook from './Sketchbook.js'

import './SketchbookDetail.css'

const Photos = (props) => {

	const [images, setImages] = useState([]);

	useEffect(() => {

		const gallery = props.images.map(async (image, index) => {
			const url = image;
			try {
				const { width, height } = await reactImageSize(url);

				return ({
					original: url,
					thumbnail: url,
				});
			} catch {
				return null;
			}
		})

		Promise.all(gallery).then(function (images) {
			setImages(images.filter(Boolean));
		});
	}, []);

	return (
		<div>
			<div className='watermark'>
				Photos by <a href="https://www.sophiemutevelian.com" target="_blank" rel="noopener noreferrer">Sophie Mutevelian</a>
			</div>
			<ImageGallery
				items={images}
				showFullscreenButton={false}
				showPlayButton={false}
				showNav={false}/>
		</div>
	);

}

const SketchbookDetail = (props) => {

	const isSketchbookDetailOpen = props.isSketchbookDetailOpen
	const setSketchbookDetailOpen = props.setSketchbookDetailOpen

	const sketchbookDetailOpenClass = isSketchbookDetailOpen ? 'sketchbook-detail-open' : '';

	function importAll(r) {
		return r.keys().map(r);
	}

	const images = importAll(
		require.context("../public/res/photos", false, /^(?!.*Sophie-Mutevelian-1).*\.(png|jpe?g|svg)$/)
	);

	return (
		<div className={`sketchbook-detail ${sketchbookDetailOpenClass}`}>
			<div className='sketchbook-detail-close' onClick={() => setSketchbookDetailOpen(false)}>
				<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
					<path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z"></path>
				</svg>
			</div>
			<div className='sketchbook-detail-content'>
				<Photos
					images={images}/>
			</div>
		</div>
	);

};

export default SketchbookDetail;